import {
  CARACTERISTICAS_NOME,
  CAPACIDADE_MAXIMA,
  ELENCO_MAX,
  NOME_FUNCAO,
  VAGAS_ACESSO,
  nomeDaLiga,
  DIVISOES_MUNDO,
  tabelaDaLiga,
  clubesDaDivisao,
  divisaoDoHumano,
  ehRodadaDeCopa,
  type HistoricoTemporada,
  calendarioDaLiga,
  jogosDaRodadaMundo,
  tabelaDaLigaMundo,
  ehRodadaDeLibertadores,
  SALDO_DEMISSAO,
  funcaoDe,
  numeroRodadaLiga,
  textoRodada,
  PRECOS_SUGERIDOS,
  Rng,
  calcularSalario,
  gerarLigaSerieA2026,
  gerarLigaSerieB2026,
  clubePorId,
  custoExpansao,
  nomeCompeticao,
  nomeEstadio,
  SERIE_A_2026,
  PAISES_MUNDO,
  clubesDaLiga,
  forcaDoJogador,
  jogadoresExternos,
  precoExterno,
  type JogadorExterno,
  SERIE_B_2026,
  dataDaRodada,
  notaMedia,
  precoPedido,
  tabela,
  type Clube,
  type DivisaoClube,
  type EstadoJogo,
  type Jogador,
  type Posicao,
} from '../core';
import { escudoMundo } from './icones';
import { abaTrofeusClube, chaveamento, corpoChaveamento, corpoLibertadores, secaoLeiloar, textoContrato } from './abas';
import { classeReal, marcaTecnico } from './tecnicos-reais';
import { blocoHabilidades } from './habilidades';
import { usuarioDaConta } from './online';
import { estadoSelo } from './selo';
import { campoDinheiro } from './dinheiro';
import { secaoAparencia } from './tema';
import { somLigado } from './som';
import { app, temporadaAcabou, humano, jogoAtual, type ResultadoProcura } from './app';
import { escudo, icone, logoCampeonato, rosto } from './icones';
import { elencoOrdenado, textoCaracteristicas } from './principal';
import { NOME_POSICAO, classeIdade, dataBR, dinheiroCurto, dinheiroExtenso, esc, estrelasHtml, num, ordinal } from './util';

export function dialogo(titulo: string, corpo: string, classe = '', fechar = 'fechar'): string {
  return `<div class="bf-overlay" role="dialog" aria-modal="true" aria-label="${esc(titulo)}">
    <div class="bf-dlg ${classe}"><button class="dlg-x" data-a="${fechar}" aria-label="Fechar">X</button>${corpo}</div></div>`;
}

// ---- Tabelas -----------------------------------------------------------------------------------

function artilheiros(clubes: Clube[]): string {
  const lista: { j: Jogador; c: Clube }[] = [];
  for (const c of clubes) for (const j of c.elenco) if (j.gols > 0) lista.push({ j, c });
  lista.sort((a, b) => b.j.gols - a.j.gols || a.j.jogos - b.j.jogos).splice(5);
  const linhas = lista.length
    ? lista.map((x) => `<li><span>${esc(x.j.nome)} <i class="cinza">(${esc(x.c.sigla)})</i></span><b>${x.j.gols}</b><b>${x.j.jogos}</b></li>`).join('')
    : '<li class="cinza">(ainda não definido)</li>';
  return `<div class="pn"><div class="pn-tit"><span>Artilheiros</span><b>G</b><b>J</b></div><ul class="pn-lista">${linhas}</ul></div>`;
}

function melhoresNotas(clubes: Clube[]): string {
  const lista: { j: Jogador; c: Clube; n: number }[] = [];
  for (const c of clubes) for (const j of c.elenco) if (j.jogos >= 3) lista.push({ j, c, n: notaMedia(j) ?? 0 });
  lista.sort((a, b) => b.n - a.n).splice(5);
  const linhas = lista.length
    ? lista.map((x) => `<li><span>${esc(x.j.nome)} <i class="cinza">(${esc(x.c.sigla)})</i></span><b>${x.n.toFixed(2).replace('.', ',')}</b><b>${x.j.jogos}</b></li>`).join('')
    : '<li class="cinza">(ainda não definido)</li>';
  return `<div class="pn"><div class="pn-tit"><span>Melhores Notas Médias</span><b>N</b><b>J</b></div><ul class="pn-lista">${linhas}</ul></div>`;
}

function estatisticasHistoria(e: EstadoJogo, clubes: Clube[]): string {
  const ids = new Set(clubes.map((c) => c.id));
  const resultados = e.resultados.filter((r) => ids.has(r.mandante) && ids.has(r.visitante));
  const jogos = resultados.length;
  const gols = resultados.reduce((s, r) => s + r.gols[0] + r.gols[1], 0);
  let goleada: { r: (typeof e.resultados)[number]; d: number } | null = null;
  for (const r of resultados) {
    const d = Math.abs(r.gols[0] - r.gols[1]);
    if (d >= 3 && (!goleada || d > goleada.d)) goleada = { r, d };
  }
  const ult = e.historico[e.historico.length - 1];
  const titulos = new Map<number, number>();
  for (const h of e.historico) titulos.set(h.campeaoId, (titulos.get(h.campeaoId) ?? 0) + 1);
  const maior = [...titulos.entries()].sort((a, b) => b[1] - a[1])[0];
  const nome = (id: number): string => esc(clubePorId(e, id).nome);
  return `<div class="pn"><div class="pn-tit"><span>Estatísticas e história</span></div><div class="pn-corpo">
    <p><b>Média de gols:</b> ${jogos ? (gols / jogos).toFixed(2).replace('.', ',') : '--'} (${gols} G/${jogos} J)</p>
    <p><b>Maior goleada:</b> ${goleada ? `${nome(goleada.r.mandante)} ${goleada.r.gols[0]} x ${goleada.r.gols[1]} ${nome(goleada.r.visitante)}` : '(ainda não há goleadas)'}</p>
    <p><b>Último campeão:</b> ${ult ? nome(ult.campeaoId) : '(ainda não definido)'}</p>
    <p><b>Maior vencedor:</b> ${maior ? `${nome(maior[0])} (${maior[1]})` : '(ainda não definido)'}</p></div></div>`;
}

function listaRodada(e: EstadoJogo, rodada: number, clubes: Clube[]): string {
  const ids = new Set(clubes.map((c) => c.id));
  const confrontos = (e.calendario[rodada] ?? []).filter((c) => ids.has(c.mandante));
  const linhas = confrontos
    .map((c) => {
      const r = e.resultados.find((x) => x.rodada === rodada && x.mandante === c.mandante);
      const m = clubePorId(e, c.mandante);
      const v = clubePorId(e, c.visitante);
      const hum = (m.humano || v.humano ? ' humano' : '') + classeReal(m, v);
      return `<tr class="${hum}"><td class="esq">${escudo(m)}${esc(m.nome)}${marcaTecnico(m)}</td><td class="placar-mini">${r ? `${r.gols[0]} x ${r.gols[1]}` : '–'}</td><td class="esq">${escudo(v)}${esc(v.nome)}${marcaTecnico(v)}</td></tr>`;
    })
    .join('');
  const opcoes = e.calendario.map((_, i) => `<option value="${i}" ${i === rodada ? 'selected' : ''}>${esc(textoRodada(e, i).replace(/^Liga - /, ''))}</option>`).join('');
  return `<label class="campo-linha">Rodada <select data-ch="rodada-tab">${opcoes}</select></label>
    <table class="tab-dlg"><tbody>${linhas}</tbody></table>`;
}

/** Abas do topo das Tabelas: nacional (Série A, Série B e Copa do Brasil) e internacional (Série A da Itália); as outras ainda não têm conteúdo. */
function abasTabelas(e: EstadoJogo, ativa: 'nacional' | 'internacional'): string {
  const aba = (id: 'nacional' | 'internacional'): string =>
    `<span class="aba ${ativa === id ? 'ativa' : 'off'}" data-a="tab-aba" data-p="${id}" role="button" tabindex="0" style="cursor:pointer">${id}</span>`;
  return `<div class="dlg-abas">${aba('nacional')}${aba('internacional')}<span class="aba off">seleções</span><span class="aba off">estadual</span>
    ${seletorTemporada(e)}</div>`;
}

const anoDaTemporada = (_e: EstadoJogo, temporada: number): number => dataDaRodada(temporada, 0).getUTCFullYear();

/** Ano no canto das Tabelas: com temporadas já encerradas vira uma lista para ver as tabelas delas (a mais nova primeiro). */
function seletorTemporada(e: EstadoJogo): string {
  const passadas = e.historico.map((h) => h.temporada).sort((a, b) => b - a);
  if (passadas.length === 0) return `<b class="dlg-ano">${anoDaTemporada(e, e.temporada)}</b>`;
  const escolhida = app.tabelas.temporada ?? e.temporada;
  const op = (t: number, rotulo: string): string => `<option value="${t}" ${escolhida === t ? 'selected' : ''}>${rotulo}</option>`;
  return `<select class="dlg-ano" data-ch="tab-temp" aria-label="Temporada">${op(e.temporada, `${anoDaTemporada(e, e.temporada)} (atual)`)}${passadas.map((t) => op(t, String(anoDaTemporada(e, t)))).join('')}</select>`;
}

/** Tabelas de uma temporada que já passou: classificação final, chaveamento da Copa e Libertadores guardados no encerramento dela. */
function dlgTabelasPassada(e: EstadoJogo, h: HistoricoTemporada, escolhida: CampeonatoTab, fechar: string): string {
  const existe = (id: number): boolean => e.clubes.some((c) => c.id === id) || Boolean(e.libertadores?.clubesExternos.some((c) => c.id === id));
  const ano = anoDaTemporada(e, h.temporada);
  let corpo: string;
  if (escolhida === 'copa') {
    corpo = h.copaFases?.length
      ? chaveamento(e, { nome: 'Copa do Brasil', fases: h.copaFases, campeaoId: h.copaCampeaoId ?? h.copaFases.at(-1)?.confrontos[0]?.vencedor ?? null, fixa: true, logo: 'copa', rodape: `Chaveamento da Copa do Brasil de ${ano}.`, ano })
      : '<div class="dlg-corpo"><p class="cinza peq">Esta temporada não teve Copa do Brasil.</p></div>';
  } else if (escolhida === 'lib') {
    corpo = h.libGrupos?.length ? corpoLibertadores(e, { grupos: h.libGrupos, fases: h.libFases ?? [], campeaoId: h.libCampeaoId ?? null, ano }) : '<div class="dlg-corpo"><p class="cinza peq">Esta temporada não teve Libertadores.</p></div>';
  } else if (escolhida === 'sul') {
    corpo = h.sulGrupos?.length ? corpoLibertadores(e, { grupos: h.sulGrupos, fases: h.sulFases ?? [], campeaoId: h.sulCampeaoId ?? null, ano }, 'sul') : '<div class="dlg-corpo"><p class="cinza peq">Esta temporada não teve Sul-Americana.</p></div>';
  } else {
    const t = (escolhida === 'b' ? h.tabelaB : h.tabelaA)?.filter((l) => existe(l.clubeId));
    if (!t?.length) {
      corpo = '<div class="dlg-corpo"><p class="cinza peq">Esta temporada não tem a classificação guardada (ela foi jogada antes do histórico das tabelas existir).</p></div>';
    } else {
      const n = t.length;
      const linhas = t
        .map((l, i) => {
          const c = clubePorId(e, l.clubeId);
          const barra = i < VAGAS_ACESSO ? 'zona-t' : i >= n - VAGAS_ACESSO && (!e.acesso || escolhida === 'a') ? 'zona-q' : '';
          return `<tr class="${barra}${c.humano ? ' humano' : ''}"><td>${i + 1}</td><td class="esq">${escudo(c)}${esc(c.nome)}</td>
            <td>${l.pts}</td><td>${l.pj}</td><td>${l.v}</td><td>${l.e}</td><td>${l.d}</td><td>${l.gp}</td><td>${l.gc}</td><td>${l.sg}</td></tr>`;
        })
        .join('');
      corpo = `<div class="dlg-corpo"><div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq"></th><th>PG</th><th>J</th><th>V</th><th>E</th><th>D</th><th>GP</th><th>GC</th><th>SG</th></tr></thead><tbody>${linhas}</tbody></table></div></div>`;
    }
  }
  return dialogo('Tabelas', `${abasTabelas(e, 'nacional')}<div class="dlg-corpo">${comboCampeonato(escolhida)}</div>${corpo}${fechar}`, 'grande');
}

type CampeonatoTab = 'a' | 'b' | 'copa' | 'lib' | 'sul';

function comboCampeonato(escolhida: CampeonatoTab, extra = ''): string {
  const op = (v: CampeonatoTab, nome: string): string => `<option value="${v}" ${escolhida === v ? 'selected' : ''}>${nome}</option>`;
  const logo = logoCampeonato(escolhida === 'copa' ? 'copa' : escolhida === 'b' ? 'serie-b' : escolhida === 'lib' ? 'libertadores' : escolhida === 'sul' ? 'sulamericana' : 'liga', 30);
  const e = jogoAtual();
  // jogo numa liga estrangeira: só a liga dela
  if (e.ligaMundo) return `<div class="combos">${logoCampeonato('liga', 30)}<select data-ch="tab-camp" aria-label="Campeonato" disabled><option>${esc(e.nomeLiga ?? 'Liga')}</option></select>${extra}</div>`;
  const lib = e.libertadores || e.historico.some((h) => h.libGrupos?.length) ? op('lib', 'Copa Libertadores') : '';
  const sul = e.sulamericana || e.historico.some((h) => h.sulGrupos?.length) ? op('sul', 'Copa Sul-Americana') : '';
  return `<div class="combos">${logo}<select data-ch="tab-camp" aria-label="Campeonato">${op('a', 'Brasileirão Série A')}${op('b', 'Brasileirão Série B')}${op('copa', 'Copa do Brasil')}${lib}${sul}</select>${extra}</div>`;
}

/** Jogo solo: o caixa fechou a temporada em -R$ 10 milhões ou pior e o técnico é demitido; ele escolhe a proposta de um clube da CPU. */
export function dlgDemissao(): string {
  const e = jogoAtual();
  const d = app.demissao;
  if (!d) return '';
  const linhas = d.propostas
    .map((id) => e.clubes.find((c) => c.id === id))
    .filter((c): c is Clube => Boolean(c))
    .map(
      (c) => `<tr><td class="esq">${escudo(c)}${esc(c.nome)}</td><td>${c.liga ? esc(nomeDaLiga(c.liga)) : e.acesso ? (c.divisao === 2 ? 'Série B' : 'Série A') : '–'}</td><td>${c.nivel}</td><td>${dinheiroCurto(c.caixa)}</td>
        <td><button class="btn peq principal" data-a="demissao-aceitar" data-id="${c.id}">Aceitar</button></td></tr>`,
    )
    .join('');
  return dialogo(
    'Demissão',
    d.convite
      ? `<div class="dlg-corpo"><div class="dlg-tit amarelo">Convites de emprego</div>
      <p>Pelo desempenho nesta temporada, clubes querem você como técnico (campeões recebem convites de ligas de outros países; quem foi bem recebe de clubes maiores). Você pode aceitar um deles ou seguir no ${esc(humano().nome)}.</p>
      <p class="cinza peq">Se aceitar, o clube vem do jeito que está (com a diretoria e a torcida em 70%) e você assume na temporada seguinte; este clube vira da CPU.</p>
      <div class="rolavel"><table class="tab-dlg"><thead><tr><th class="esq">Clube</th><th>Liga</th><th>Nível</th><th>Caixa</th><th></th></tr></thead><tbody>${linhas}</tbody></table></div>
      <div class="dlg-botoes"><button class="btn" data-a="convite-recusar">Recusar e seguir no clube</button></div></div>`
      : `<div class="dlg-corpo"><div class="dlg-tit amarelo">Você foi demitido do ${esc(d.de)}</div>
      <p>A temporada terminou com o caixa em <b>${dinheiroExtenso(d.saldo)}</b>. A diretoria não aceita saldo de ${dinheiroExtenso(SALDO_DEMISSAO)} ou pior, e o seu contrato foi rescindido.</p>
      <p class="cinza peq">Estes clubes querem você como técnico. Escolha um para seguir na carreira (o clube vem do jeito que está, com a diretoria e a torcida em 70%).</p>
      <div class="rolavel"><table class="tab-dlg"><thead><tr><th class="esq">Clube</th><th>Liga</th><th>Nível</th><th>Caixa</th><th></th></tr></thead><tbody>${linhas}</tbody></table></div></div>`,
    '',
    'demissao-adiar',
  );
}
/** Aba internacional num jogo com o mundo inteiro: classificação, jogos e elencos reais de uma liga estrangeira. */
function dlgInternacionalMundo(e: EstadoJogo, pais: { nome: string }, ligaId: string, ligaNome: string, comboPais: string, comboLiga: string, fechar: string): string {
  const clubes = e.clubes.filter((c) => c.liga === ligaId).sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
  const escolhido = clubes.find((c) => c.nome === app.tabelas.clubeLiga);
  const opt = (v: string, nome: string, marcado: boolean): string => `<option value="${esc(v)}" ${marcado ? 'selected' : ''}>${esc(nome)}</option>`;
  const comboClube = `<select data-ch="tab-clube-it" aria-label="Clube">${opt('', 'Todos os clubes', !escolhido)}${clubes.map((c) => opt(c.nome, c.nome, c === escolhido)).join('')}</select>`;
  let corpo: string;
  if (escolhido) {
    const ordem = ['G', 'Z', 'L', 'M', 'A'];
    const elenco = [...escolhido.elenco].sort((a, b) => ordem.indexOf(a.posicao) - ordem.indexOf(b.posicao) || b.overall - a.overall);
    const linhas = elenco.map((j, i) => `<tr><td>${i + 1}</td><td class="esq">${esc(j.nome)}${estrelasHtml(j)}</td><td class="esq">${NOME_POSICAO[j.posicao]}</td><td>${j.idade}</td><td><b>${j.overall}</b></td><td>${dinheiroCurto(j.valor)}</td></tr>`).join('');
    corpo = `<div class="times-cab">${escudo(escolhido, true)}<div><b>${esc(escolhido.nome)}</b><br><span class="cinza">${esc(nomeEstadio(escolhido))} · caixa ${dinheiroCurto(escolhido.caixa)} · ${escolhido.elenco.length} jogadores</span></div></div>
      <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq">Jogador</th><th class="esq">Posição</th><th>Idade</th><th>Força</th><th>Valor</th></tr></thead><tbody>${linhas}</tbody></table></div>`;
  } else {
    const t = tabelaDaLiga(e, ligaId);
    const div = DIVISOES_MUNDO.find((d) => d.primeira === ligaId || d.segunda === ligaId);
    const n = t.length;
    const linhasTab = t
      .map((l, i) => {
        const c = clubePorId(e, l.clubeId);
        let zona = '';
        if (div && ligaId === div.primeira && i >= n - div.vagas) zona = 'zona-q';
        else if (div && ligaId === div.segunda && i < div.vagas) zona = 'zona-t';
        else if (ligaId === 'ar-1' && i < 16) zona = i < 8 ? 'zona-t' : 'zona-s';
        return `<tr class="${zona}${c.humano ? ' humano' : ''}"><td>${i + 1}</td><td class="esq">${escudo(c)}${esc(c.nome)}</td><td><b>${l.pts}</b></td><td>${l.pj}</td><td>${l.v}</td><td>${l.e}</td><td>${l.d}</td><td>${l.gp}</td><td>${l.gc}</td><td>${l.sg}</td></tr>`;
      })
      .join('');
    const nota = div ? (ligaId === div.primeira ? `Os ${div.vagas} últimos caem para a divisão de baixo.` : `Os ${div.vagas} primeiros sobem para a divisão de cima.`) : ligaId === 'ar-1' ? 'Os 8 primeiros ganham vaga na Libertadores seguinte e do 9º ao 16º, na Sul-Americana.' : 'Esta liga não tem acesso e rebaixamento no jogo.';
    // jogos: as rodadas de liga do calendário (as das copas ficam de fora), com o placar das já jogadas
    const reservadas = new Set([...(e.copa?.slots ?? []), ...(e.libertadores?.slots ?? []), ...(e.sulamericana?.slots ?? [])]);
    const idx = e.calendario.map((_, i) => i).filter((i) => !reservadas.has(i) && (e.calendario[i] ?? []).some((c) => clubePorId(e, c.mandante).liga === ligaId));
    const jogadas = idx.filter((i) => i < e.rodada).length;
    const r = Math.min(app.tabelas.rodadaMundo ?? Math.max(0, jogadas - 1), Math.max(0, idx.length - 1));
    const opcoes = idx.map((_, k) => `<option value="${k}" ${k === r ? 'selected' : ''}>Rodada ${k + 1}${k < jogadas ? '' : ' (a jogar)'}</option>`).join('');
    const jogos = (e.calendario[idx[r] ?? -1] ?? [])
      .filter((c) => clubePorId(e, c.mandante).liga === ligaId)
      .map((c) => {
        const res = e.resultados.find((x) => x.rodada === idx[r] && x.mandante === c.mandante && x.visitante === c.visitante);
        const m = clubePorId(e, c.mandante);
        const v = clubePorId(e, c.visitante);
        return `<tr class="${m.humano || v.humano ? 'humano' : ''}"><td class="esq">${escudo(m)}${esc(m.nome)}</td><td class="placar-mini">${res ? `${res.gols[0]} x ${res.gols[1]}` : '–'}</td><td class="esq">${escudo(v)}${esc(v.nome)}</td></tr>`;
      })
      .join('');
    corpo = `<div class="dlg-tit amarelo">Classificação · ${dataDaRodada(e.temporada, 0).getUTCFullYear()}</div><p class="cinza peq">${nota}</p>
      <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq">Clube</th><th>PG</th><th>J</th><th>V</th><th>E</th><th>D</th><th>GP</th><th>GC</th><th>SG</th></tr></thead><tbody>${linhasTab}</tbody></table></div>
      <div class="dlg-tit amarelo">Calendário</div><label class="campo-linha">Rodada <select data-ch="rodada-mundo">${opcoes}</select></label><table class="tab-dlg"><tbody>${jogos}</tbody></table>`;
  }
  return dialogo('Tabelas', `${abasTabelas(e, 'internacional')}<div class="dlg-corpo"><div class="dlg-tit amarelo">${esc(ligaNome)} · ${esc(pais.nome)}</div><div class="combos">${comboPais}${comboLiga}${comboClube}</div>${corpo}</div>${fechar}`, 'grande');
}

export function dlgTabelas(): string {
  const e = jogoAtual();
  const minha: 'a' | 'b' = divisaoDoHumano(e) === 2 ? 'b' : 'a';
  const escolhida: CampeonatoTab = e.ligaMundo ? 'a' : (app.tabelas.campeonato ?? (e.formato === 'copa' ? 'copa' : minha));
  const fechar = '<div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>';
  const passada = app.tabelas.temporada !== undefined && app.tabelas.temporada !== e.temporada ? e.historico.find((h) => h.temporada === app.tabelas.temporada) : undefined;
  if (passada && app.tabelas.aba !== 'internacional') return dlgTabelasPassada(e, passada, escolhida, fechar);
  if (app.tabelas.aba === 'internacional') {
    // ligas estrangeiras: só cadastro (clubes, elencos, idade e valor), sem força nem calendário: ver ligas-mundo.ts
    const pais = PAISES_MUNDO.find((p) => p.nome === app.tabelas.pais);
    const liga = pais?.ligas.find((l) => l.id === app.tabelas.liga) ?? pais?.ligas[0];
    const clubes = liga ? clubesDaLiga(liga.id) : [];
    const escolhido = clubes.find((c) => c.nome === app.tabelas.clubeLiga);
    const sel = (v: string, nome: string, marcado: boolean): string => `<option value="${esc(v)}" ${marcado ? 'selected' : ''}>${esc(nome)}</option>`;
    const comboPais = `<select data-ch="tab-pais" aria-label="País">${sel('', 'País', !pais)}${PAISES_MUNDO.map((p) => sel(p.nome, p.nome, p === pais)).join('')}</select>`;
    const comboLiga = pais && pais.ligas.length > 1 ? `<select data-ch="tab-liga" aria-label="Liga">${pais.ligas.map((l) => sel(l.id, l.nome, l === liga)).join('')}</select>` : '';
    const comboClube = liga ? `<select data-ch="tab-clube-it" aria-label="Clube">${sel('', 'Todos os clubes', !escolhido)}${clubes.map((c) => sel(c.nome, c.nome, c === escolhido)).join('')}</select>` : '';
    // jogo com o mundo inteiro: as ligas estrangeiras têm clubes, tabela e jogos de verdade
    if (e.mundo && pais && liga) return dlgInternacionalMundo(e, pais, liga.id, liga.nome, comboPais, comboLiga, fechar);
    const mi = (v: number): string => (v > 0 ? `R$ ${v.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} mi` : '—');
    let titulo = 'Ligas do mundo';
    let corpo: string;
    if (!liga || !pais) {
      titulo = 'Escolha um país';
      corpo = `<p class="cinza peq">Escolha um país para ver as ligas, os clubes e os elencos. A força dos jogadores vem do valor de mercado, como na Série A e B. Cada liga tem o seu calendário e joga junto com as rodadas do Brasileirão, controlada pela CPU (por enquanto você não pode escolher um clube dela). Escolha a liga para ver a classificação e os jogos. Os 8 primeiros da Argentina ganham vaga na Libertadores seguinte e do 9º ao 16º, na Sul-Americana.</p>
          <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th class="esq">País</th><th class="esq">Liga</th><th>Clubes</th></tr></thead><tbody>${PAISES_MUNDO.flatMap((p) =>
            p.ligas.map((l) => `<tr><td class="esq">${esc(p.nome)}</td><td class="esq">${esc(l.nome)}</td><td>${clubesDaLiga(l.id).length}</td></tr>`),
          ).join('')}</tbody></table></div>`;
    } else if (escolhido) {
      titulo = `${liga.nome} · ${pais.nome}`;
      const linhas = escolhido.elenco.map((j, i) => `<tr><td>${i + 1}</td><td class="esq">${esc(j[0])}</td><td class="esq">${esc(j[1])}</td><td>${j[2] > 0 ? j[2] : '—'}</td><td><b>${forcaDoJogador(j) ?? '—'}</b></td><td>${mi(j[3])}</td></tr>`).join('');
      const detalhe = [escolhido.estadio, escolhido.cidade].filter(Boolean).join(' · ');
      corpo = `<p class="cinza peq">${detalhe ? `${esc(detalhe)} · ` : ''}${escolhido.elenco.length} jogadores</p>
            <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq">Jogador</th><th class="esq">Posição</th><th>Idade</th><th>Força</th><th>Valor</th></tr></thead><tbody>${linhas}</tbody></table></div>`;
    } else {
      titulo = `${liga.nome} · ${pais.nome}`;
      const comLocal = clubes.some((c) => c.estadio);
      // classificação da liga: a temporada em andamento (joga junto com as rodadas do Brasileirão) ou, antes da 1ª rodada, a última simulada
      const viva = e.ligasMundoVivas?.[liga.id];
      const aoVivo = viva && viva.jogadas > 0 ? tabelaDaLigaMundo(e, liga.id) : null;
      const sim = e.ligasMundo?.[liga.id];
      const linhasTab = aoVivo ?? sim?.tabela ?? null;
      const vagasLib = liga.id === 'ar-1' ? 4 : 0;
      const tituloTab = aoVivo && viva ? `Classificação da temporada ${dataDaRodada(viva.temporada, 0).getUTCFullYear()} · ${viva.jogadas} rodada${viva.jogadas > 1 ? 's' : ''} jogada${viva.jogadas > 1 ? 's' : ''}` : sim ? `Classificação final da temporada ${dataDaRodada(sim.temporada, 0).getUTCFullYear()}` : '';
      const tabelaLiga = linhasTab
        ? `<div class="dlg-tit amarelo">${tituloTab}</div>${vagasLib ? '<p class="cinza peq">Os 8 primeiros ganham vaga na Copa Libertadores seguinte e do 9º ao 16º, na Sul-Americana.</p>' : ''}
          <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq">Clube</th><th>PG</th><th>J</th><th>V</th><th>E</th><th>D</th><th>GP</th><th>GC</th><th>SG</th></tr></thead><tbody>${linhasTab
            .map((l, i) => `<tr class="${i < vagasLib ? 'zona-t' : ''}"><td>${i + 1}</td><td class="esq">${escudoMundo(l.clube)}${esc(l.clube)}</td><td><b>${l.pts}</b></td><td>${l.v + l.e + l.d}</td><td>${l.v}</td><td>${l.e}</td><td>${l.d}</td><td>${l.gp}</td><td>${l.gc}</td><td>${l.gp - l.gc}</td></tr>`)
            .join('')}</tbody></table></div>`
        : '';
      // rodadas: o calendário da liga, com os placares das já jogadas
      let rodadasLiga = '';
      if (viva) {
        const total = calendarioDaLiga(e.semente, viva.temporada, liga.id).rodadas.length;
        const ultima = Math.max(0, viva.jogadas - 1);
        const r = Math.min(app.tabelas.rodadaMundo ?? ultima, total - 1);
        const opcoes = Array.from({ length: total }, (_, k) => `<option value="${k}" ${k === r ? 'selected' : ''}>Rodada ${k + 1}${k < viva.jogadas ? '' : ' (a jogar)'}</option>`).join('');
        const jogos = jogosDaRodadaMundo(e, liga.id, r)
          .map((g) => `<tr><td class="esq">${escudoMundo(g.casa)}${esc(g.casa)}</td><td class="placar-mini">${g.placar ? `${g.placar[0]} x ${g.placar[1]}` : '–'}</td><td class="esq">${escudoMundo(g.fora)}${esc(g.fora)}</td></tr>`)
          .join('');
        rodadasLiga = `<div class="dlg-tit amarelo">Calendário</div><label class="campo-linha">Rodada <select data-ch="rodada-mundo">${opcoes}</select></label><table class="tab-dlg"><tbody>${jogos}</tbody></table>`;
      }
      const classif = tabelaLiga + rodadasLiga + (tabelaLiga || rodadasLiga ? '<div class="dlg-tit amarelo">Clubes e elencos</div>' : '');      corpo = classif + `<p class="cinza peq">Estes são os ${clubes.length} clubes da liga. Escolha um clube para ver o elenco. Força pela média dos 11 melhores, calculada do valor de mercado como na Série A e B (€1 mi = R$ 1 mi).</p>
          <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq">Clube</th>${comLocal ? '<th class="esq">Estádio</th><th class="esq">Cidade</th>' : ''}<th>Jogadores</th>${clubes.some((c) => c.forca) ? '<th>Força</th>' : ''}</tr></thead><tbody>${clubes
            .map((c, i) => `<tr><td>${i + 1}</td><td class="esq">${escudoMundo(c.nome)}${esc(c.nome)}</td>${comLocal ? `<td class="esq">${esc(c.estadio ?? '')}</td><td class="esq">${esc(c.cidade ?? '')}</td>` : ''}<td>${c.elenco.length}</td>${clubes.some((x) => x.forca) ? `<td><b>${c.forca ?? '—'}</b></td>` : ''}</tr>`)
            .join('')}</tbody></table></div>`;
    }
    return dialogo(
      'Tabelas',
      `${abasTabelas(e, 'internacional')}
      <div class="dlg-corpo"><div class="dlg-tit amarelo">${esc(titulo)}</div>
        <div class="combos">${comboPais}${comboLiga}${comboClube}</div>
        ${corpo}</div>
      ${fechar}`,
      'grande',
    );
  }
  if (escolhida === 'lib' && e.libertadores) {
    return dialogo('Tabelas', `${abasTabelas(e, 'nacional')}<div class="dlg-corpo">${comboCampeonato('lib')}</div>${corpoLibertadores(e)}${fechar}`, 'grande');
  }
  if (escolhida === 'sul' && e.sulamericana) {
    return dialogo('Tabelas', `${abasTabelas(e, 'nacional')}<div class="dlg-corpo">${comboCampeonato('sul')}</div>${corpoLibertadores(e, undefined, 'sul')}${fechar}`, 'grande');
  }
  if (escolhida === 'copa') {
    const corpo = e.copa
      ? corpoChaveamento(e)
      : '<div class="dlg-corpo"><p class="cinza peq">Este jogo não tem a Copa do Brasil. Comece um novo jogo em "Brasileirão + Copa do Brasil" para disputar os dois campeonatos no mesmo save.</p></div>';
    return dialogo('Tabelas', `${abasTabelas(e, 'nacional')}<div class="dlg-corpo">${comboCampeonato('copa')}</div>${corpo}${fechar}`, 'grande');
  }
  if (escolhida !== minha && !e.acesso) {
    // campeonato de outra divisão: mostra os clubes dele (para disputá-lo, comece um novo jogo escolhendo a divisão)
    const lista = (escolhida === 'b' ? SERIE_B_2026 : SERIE_A_2026).map((c) => `<li>${esc(c.nome)} <span class="cinza">· ${esc(nomeEstadio(c))}</span></li>`).join('');
    return dialogo(
      'Tabelas',
      `${abasTabelas(e, 'nacional')}
      <div class="dlg-corpo">${comboCampeonato(escolhida)}
        <p class="cinza peq">Você está disputando outra divisão. Estes são os 20 clubes deste campeonato; para jogá-lo, comece um novo jogo e escolha o campeonato.</p><ul class="lista-clubes">${lista}</ul></div>
      ${fechar}`,
      'grande',
    );
  }
  // com Série A e B no jogo, as duas têm tabela de verdade; senão, só a divisão que o técnico disputa
  const divisaoTab: DivisaoClube = escolhida === 'b' ? 2 : 1;
  const clubesTab = e.acesso ? clubesDaDivisao(e, divisaoTab) : e.clubes;
  const t = tabela(e, divisaoTab);
  const n = t.length;
  const linhas = t
    .map((l, i) => {
      const c = clubePorId(e, l.clubeId);
      // liga estrangeira ainda não tem rebaixamento nem vagas continentais: sem as faixas de cor
      const barra = e.ligaMundo ? '' : i < VAGAS_ACESSO ? 'zona-t' : i >= n - VAGAS_ACESSO && (!e.acesso || divisaoTab === 1) ? 'zona-q' : '';
      return `<tr class="${barra}${c.humano ? ' humano' : ''}${classeReal(c)}"><td>${i + 1}</td><td class="esq">${escudo(c)}${esc(c.nome)}${marcaTecnico(c)}</td>
        <td>${l.pts}</td><td>${l.pj}</td><td>${l.v}</td><td>${l.e}</td><td>${l.d}</td><td>${l.gp}</td><td>${l.gc}</td><td>${l.sg}</td></tr>`;
    })
    .join('');
  const rod = Math.min(app.tabelas.rodada, Math.max(0, e.calendario.length - 1));
  const direita =
    app.tabelas.painel === 'rodadas'
      ? `<div class="pn"><div class="pn-tit"><span>Rodadas</span></div><div class="pn-corpo">${listaRodada(e, rod, clubesTab)}</div></div>`
      : `${artilheiros(clubesTab)}${melhoresNotas(clubesTab)}${estatisticasHistoria(e, clubesTab)}`;
  return dialogo(
    'Tabelas',
    `${abasTabelas(e, 'nacional')}
    <div class="dlg-corpo duas">
      <div>${comboCampeonato(escolhida)}
        <div class="rolavel"><table class="tab-dlg classificacao"><thead><tr><th></th><th class="esq"></th><th>PG</th><th>J</th><th>V</th><th>E</th><th>D</th><th>GP</th><th>GC</th><th>SG</th></tr></thead><tbody>${linhas}</tbody></table></div></div>
      <div>${direita}
        <div class="dlg-botoes"><button class="btn ${app.tabelas.painel === 'estatisticas' ? 'ativo' : ''}" data-a="tab-painel" data-p="estatisticas">Estatísticas</button>
          <button class="btn ${app.tabelas.painel === 'rodadas' ? 'ativo' : ''}" data-a="tab-painel" data-p="rodadas">Rodadas</button></div></div>
    </div>`,
    'grande',
  );
}

// ---- Estádio -----------------------------------------------------------------------------------

export function dlgEstadio(): string {
  const c = humano();
  const setores = [0.15, 0.75, 0.09, 0.01].map((p) => Math.round(c.capacidade * p));
  const nomes = ['Geral', 'Arquibancada', 'Cadeira', 'Camarote'];
  const prec = c.usarPrecosSugeridos ? PRECOS_SUGERIDOS : c.precos;
  const campos = nomes
    .map(
      (n, i) =>
        `<label class="preco"><span>${n}:</span><input type="number" min="1" max="500" step="1" inputmode="numeric" value="${prec[i]}" data-ch="preco" data-i="${i}" ${c.usarPrecosSugeridos ? 'disabled' : ''} /></label>`,
    )
    .join('');
  const capac = nomes.map((n, i) => `<p><span>${n}:</span> <b>${num(setores[i] as number)}</b></p>`).join('');
  return dialogo(
    'Estádio',
    `<div class="dlg-tit amarelo">${esc(nomeEstadio(c))} (${esc(c.nome)}) - ${num(c.capacidade)} lugares</div>
    <div class="dlg-corpo duas estadio">
      <div><h3>CAPACIDADE ATUAL</h3>${capac}</div>
      <div><h3>PREÇO DOS INGRESSOS</h3>${campos}</div>
    </div>
    <p class="sugerido">Preços sugeridos: G:${PRECOS_SUGERIDOS[0]}; A:${PRECOS_SUGERIDOS[1]}; Cd:${PRECOS_SUGERIDOS[2]}; Cm:${PRECOS_SUGERIDOS[3]}</p>
    <label class="check"><input type="checkbox" data-ch="sugeridos" ${c.usarPrecosSugeridos ? 'checked' : ''} /> Usar sempre os preços sugeridos</label>
    <div class="dlg-botoes"><button class="btn" data-a="expandir" ${c.capacidade + 1000 > CAPACIDADE_MAXIMA ? 'disabled' : ''}>Expandir estádio (+1.000 lugares por ${dinheiroExtenso(custoExpansao())})</button></div>
    <p class="cinza peq">Preço abaixo do sugerido atrai mais público; acima, menos. Renda = público × preço.</p>`,
    'medio',
  );
}

// ---- Procura / Times / negociação -------------------------------------------------------------

function faixaValor(v: number, f: string): boolean {
  switch (f) {
    case 'a1':
      return v <= 1_000_000;
    case 'a3':
      return v > 1_000_000 && v <= 3_000_000;
    case 'a6':
      return v > 3_000_000 && v <= 6_000_000;
    case 'a12':
      return v > 6_000_000 && v <= 12_000_000;
    case 'b12':
      return v > 12_000_000;
    default:
      return true;
  }
}

export function executarProcura(): ResultadoProcura[] {
  const e = jogoAtual();
  const f = app.procura.filtros;
  const nome = f.nome.trim().toLowerCase();
  const res: { r: ResultadoProcura; j: Jogador }[] = [];
  const testa = (j: Jogador): boolean => {
    if (nome && !j.nome.toLowerCase().includes(nome)) return false;
    if (f.posicao && j.posicao !== f.posicao) return false;
    if (f.lado && j.lado !== f.lado) return false;
    if (j.overall < f.forcaMin || j.overall > f.forcaMax) return false;
    if (j.idade < f.idadeMin || j.idade > f.idadeMax) return false;
    if (f.car1 >= 0 && !j.caracteristicas.includes(f.car1)) return false;
    if (f.car2 >= 0 && !j.caracteristicas.includes(f.car2)) return false;
    return faixaValor(j.valor, f.valor);
  };
  // jogo com o mundo inteiro: todas as ligas têm clubes de verdade, então o filtro "campeonato" escolhe entre elas (e não há jogador "externo")
  const ligaFiltro = e.mundo && f.campeonato !== 'br' && f.campeonato !== 'todos' && f.campeonato !== '' ? f.campeonato : null;
  const doJogo = Boolean(e.mundo) || f.campeonato === 'br' || f.campeonato === 'todos' || f.campeonato === '';
  if (doJogo && !f.livres) {
    for (const c of e.clubes) {
      if (c.id === e.humanoId) continue;
      if (e.mundo && ((ligaFiltro && c.liga !== ligaFiltro) || (f.campeonato === 'br' && c.liga))) continue;
      for (const j of c.elenco) if (testa(j)) res.push({ r: { jogadorId: j.id, clubeId: c.id }, j });
    }
  }
  if (doJogo && !ligaFiltro) for (const j of e.livres) if (testa(j)) res.push({ r: { jogadorId: j.id, clubeId: null }, j });
  const todos = res.map((x) => ({ r: x.r, forca: x.j.overall }));
  // jogadores de ligas estrangeiras: dá para comprá-los, mas não têm característica nem gols; sem valor ou idade na planilha, o filtro não os exclui
  if (!e.mundo && f.campeonato !== 'br' && f.campeonato !== '' && !f.livres && f.car1 < 0 && f.car2 < 0) {
    for (const x of jogadoresExternos()) {
      if (f.campeonato !== 'todos' && x.ligaId !== f.campeonato) continue;
      if (e.externosComprados?.includes(x.id)) continue;
      if (e.ligaMundo && x.ligaId === e.ligaMundo) continue; // os jogadores da liga do jogo já estão nos clubes dela
      if (nome && !x.nome.toLowerCase().includes(nome)) continue;
      if (f.posicao && x.posicao !== f.posicao) continue;
      if (f.lado && x.lado !== f.lado) continue;
      if (x.forca !== null ? x.forca < f.forcaMin || x.forca > f.forcaMax : f.forcaMin > 1) continue;
      if (x.idade > 0 && (x.idade < f.idadeMin || x.idade > f.idadeMax)) continue;
      if (f.valor && !(x.valorMi > 0 && faixaValor(x.valorMi * 1_000_000, f.valor))) continue;
      todos.push({ r: { jogadorId: x.id, clubeId: null }, forca: x.forca ?? 0 });
    }
  }
  todos.sort((a, b) => b.forca - a.forca);
  return todos.slice(0, 150).map((x) => x.r);
}

function externoPorId(id: number): JogadorExterno | undefined {
  return jogadoresExternos()[-id - 1];
}

function jogadorDe(e: EstadoJogo, r: ResultadoProcura): { j: Jogador; c: Clube | null } | null {
  if (r.clubeId === null) {
    const j = e.livres.find((x) => x.id === r.jogadorId);
    return j ? { j, c: null } : null;
  }
  const c = clubePorId(e, r.clubeId);
  const j = c.elenco.find((x) => x.id === r.jogadorId);
  return j ? { j, c } : null;
}

function botoesCompra(e: EstadoJogo, r: ResultadoProcura | null): string {
  const h = humano();
  const ext = r && r.jogadorId < 0 ? externoPorId(r.jogadorId) : undefined;
  if (ext) {
    const preco = precoExterno(ext);
    const cheio = h.elenco.length >= ELENCO_MAX;
    return `<div class="dlg-botoes"><span class="rotulo-sel">${esc(ext.nome)} · ${esc(ext.clube)} (${esc(ext.liga)}, ${esc(ext.pais)}) — pedido ${dinheiroExtenso(preco)}</span>
      <button class="btn principal" data-a="comprar-externo" data-id="${ext.id}" ${h.caixa < preco || cheio ? 'disabled' : ''}>Comprar</button></div>`;
  }
  const dados = r ? jogadorDe(e, r) : null;
  if (!dados || !r) {
    return `<div class="dlg-botoes"><button class="btn" disabled>Comprar</button><button class="btn" disabled>Fazer oferta</button></div>`;
  }
  const { j, c } = dados;
  const dado = `data-id="${j.id}" data-club="${r.clubeId ?? ''}"`;
  const cheio = h.elenco.length >= ELENCO_MAX;
  if (!c) {
    return `<div class="dlg-botoes"><span class="rotulo-sel">${esc(j.nome)} (livre) — salário ${dinheiroCurto(calcularSalario(j.overall, j.idade, j.posicao, h.nivel))}/mês</span>
      <button class="btn principal" data-a="contratar-livre" ${dado} ${cheio ? 'disabled' : ''}>Contratar</button></div>`;
  }
  const pedido = precoPedido(j, c);
  const deHumano = Boolean(app.online && c.humano);
  return `<div class="dlg-botoes"><span class="rotulo-sel">${esc(j.nome)} — pedido ${dinheiroExtenso(pedido)}${deHumano ? ' <i class="cinza">(técnico humano: só por oferta)</i>' : ''}</span>
    <button class="btn principal" data-a="comprar" ${dado} ${h.caixa < pedido || cheio || deHumano ? 'disabled' : ''} ${deHumano ? 'title="Jogador de outro técnico: faça uma oferta"' : ''}>Comprar</button>
    <button class="btn" data-a="oferta" ${dado} ${cheio ? 'disabled' : ''}>Fazer oferta</button></div>`;
}

export function dlgProcura(): string {
  const e = jogoAtual();
  const f = app.procura.filtros;
  const opcPos = ['', 'G', 'L', 'Z', 'M', 'A']
    .map((p) => `<option value="${p}" ${f.posicao === p ? 'selected' : ''}>${p ? NOME_POSICAO[p as Posicao] : 'Qualquer'}</option>`)
    .join('');
  const opcLado = [['', 'Qualquer'], ['E', 'Esquerdo'], ['D', 'Direito']]
    .map(([v, n]) => `<option value="${v}" ${f.lado === v ? 'selected' : ''}>${n}</option>`)
    .join('');
  const opcCar = (sel: number): string =>
    `<option value="-1">Qualquer</option>` + CARACTERISTICAS_NOME.map((n, i) => `<option value="${i}" ${sel === i ? 'selected' : ''}>${n}</option>`).join('');
  const opcValor = [['', 'Qualquer'], ['a1', 'até 1M'], ['a3', '1M a 3M'], ['a6', '3M a 6M'], ['a12', '6M a 12M'], ['b12', 'acima de 12M']]
    .map(([v, n]) => `<option value="${v}" ${f.valor === v ? 'selected' : ''}>${n}</option>`)
    .join('');
  const opcCamp = `<option value="br" ${f.campeonato === 'br' ? 'selected' : ''}>Brasil (jogáveis)</option><option value="todos" ${f.campeonato === 'todos' ? 'selected' : ''}>Todos (Brasil e ligas estrangeiras)</option>`
    + PAISES_MUNDO.map((p) => `<optgroup label="${esc(p.nome)}">${p.ligas.map((l) => `<option value="${l.id}" ${f.campeonato === l.id ? 'selected' : ''}>${esc(l.nome)}</option>`).join('')}</optgroup>`).join('');
  const linhas = app.procura.resultados
    .map((r) => {
      if (r.jogadorId < 0) {
        const x = externoPorId(r.jogadorId);
        if (!x) return '';
        const selx = app.procura.sel && app.procura.sel.jogadorId === r.jogadorId ? ' sel' : '';
        return `<tr class="lin${selx}" data-a="proc-sel" data-id="${x.id}" data-club="" tabindex="0"><td title="${esc(x.posicaoNome)}">${x.posicao ?? '—'}</td><td class="esq">${esc(x.nome)}</td>
          <td class="esq" title="${esc(x.liga)} · ${esc(x.pais)}">${esc(x.clube)}</td><td>${x.lado || '—'}</td><td>${x.forca ?? '—'}</td><td>—</td><td>${x.valorMi > 0 ? dinheiroCurto(x.valorMi * 1_000_000) : '—'}</td>
          <td>—</td><td>—</td><td>${x.idade > 0 ? x.idade : '—'}</td></tr>`;
      }
      const d = jogadorDe(e, r);
      if (!d) return '';
      const { j, c } = d;
      const sel = app.procura.sel && app.procura.sel.jogadorId === r.jogadorId ? ' sel' : '';
      return `<tr class="lin${sel}" data-a="proc-sel" data-id="${j.id}" data-club="${r.clubeId ?? ''}" tabindex="0"><td title="${NOME_FUNCAO[funcaoDe(j)]}">${funcaoDe(j)}</td><td class="esq">${esc(j.nome)}${estrelasHtml(j)}</td>
        <td class="esq">${c ? esc(c.sigla) : '<i class="cinza">livre</i>'}</td><td>${j.lado}</td><td>${j.overall}</td><td>${dinheiroCurto(j.salario)}</td><td>${dinheiroCurto(j.valor)}</td>
        <td>${textoCaracteristicas(j)}</td><td>${j.gols}</td><td class="${classeIdade(j.idade)}">${j.idade}</td></tr>`;
    })
    .join('');
  return dialogo(
    'Procura de jogadores',
    `<div class="dlg-corpo filtros">
      <label>Nome:<input type="text" id="f-nome" value="${esc(f.nome)}" autocomplete="off" /></label>
      <label>Característica 1:<select id="f-car1">${opcCar(f.car1)}</select></label>
      <label>Característica 2:<select id="f-car2">${opcCar(f.car2)}</select></label>
      <label>Posição:<select id="f-pos">${opcPos}</select></label>
      <label>Lado:<select id="f-lado">${opcLado}</select></label>
      <label>Campeonato:<select id="f-camp">${opcCamp}</select></label>
      <label>Valor:<select id="f-valor">${opcValor}</select></label>
      <label class="faixa">Força: <input type="number" id="f-fmin" min="1" max="100" value="${f.forcaMin}" /> a <input type="number" id="f-fmax" min="1" max="100" value="${f.forcaMax}" /></label>
      <label class="faixa">Idade: <input type="number" id="f-imin" min="16" max="45" value="${f.idadeMin}" /> a <input type="number" id="f-imax" min="16" max="45" value="${f.idadeMax}" /></label>
      <label class="check"><input type="checkbox" id="f-livres" ${f.livres ? 'checked' : ''} /> Só jogadores livres</label>
    </div>
    <div class="dlg-botoes"><button class="btn" data-a="proc-reset">Resetar filtros</button><button class="btn principal" data-a="proc-buscar">Procurar</button></div>
    <div class="rolavel resultados"><table class="tab-dlg"><thead><tr><th>P</th><th class="esq">Nome</th><th class="esq">Time</th><th>L</th><th>F</th><th>Salário</th><th>Valor</th><th>Car.</th><th>G</th><th>Idade</th></tr></thead>
      <tbody>${linhas || '<tr><td class="esq" colspan="10">Use os filtros e clique em Procurar.</td></tr>'}</tbody></table></div>
    ${botoesCompra(e, app.procura.sel)}`,
    'grande',
  );
}

let cacheOutraDivisao: { chave: string; clubes: Clube[] } | null = null;

/**
 * Clubes da divisão que o jogador NÃO disputa (Série B num jogo da Série A e vice-versa), só para consulta na aba Times.
 * São gerados com o mesmo gerador do jogo, sempre iguais para a mesma semente; os ids dos jogadores ficam longe dos do jogo.
 * Séries sem elenco real completo (a maioria da B) aparecem com jogadores gerados, marcados como estimados.
 */
export function clubesOutraDivisao(e: EstadoJogo): Clube[] {
  const divisao = e.divisao === 'b' ? 'a' : 'b';
  const chave = `${e.semente}-${divisao}`;
  if (cacheOutraDivisao?.chave === chave) return cacheOutraDivisao.clubes;
  const rng = new Rng(e.semente + 7919);
  const contador = { valor: 5_000_000 };
  const clubes = divisao === 'b' ? gerarLigaSerieB2026(rng, contador) : gerarLigaSerieA2026(rng, contador);
  cacheOutraDivisao = { chave, clubes };
  return clubes;
}

export function dlgTimes(): string {
  const e = jogoAtual();
  const outros = e.acesso || e.ligaMundo ? [] : clubesOutraDivisao(e); // com as duas divisões no jogo, todos os clubes já estão em e.clubes
  const externo = app.times.externo !== undefined ? outros[app.times.externo] : undefined;
  const alvoId = app.times.clubeId ?? e.humanoId;
  const c = externo ?? clubePorId(e, alvoId);
  const itemClube = (x: Clube): string => `<li><button class="arv ${!externo && x.id === alvoId ? 'sel' : ''}" data-a="times-clube" data-id="${x.id}">${escudo(x)}${esc(x.nome)}</button></li>`;
  const porNome = (a: Clube, b: Clube): number => a.nome.localeCompare(b.nome, 'pt-BR');
  const lista = e.acesso
    ? ''
    : [...e.clubes].sort(porNome).map(itemClube).join('');
  // com Série A e Série B no jogo: duas listas, uma por divisão
  const listaDivisao = (d: DivisaoClube): string =>
    `<div class="pn-tit"><span>${logoCampeonato(d === 2 ? 'serie-b' : 'liga', 18)}${d === 2 ? 'Brasileirão Série B' : 'Brasileirão Série A'}</span></div><ul class="arvore">${clubesDaDivisao(e, d).sort(porNome).map(itemClube).join('')}</ul>`;
  const nomeOutra = e.divisao === 'b' ? 'Brasileirão Série A' : 'Brasileirão Série B';
  const listaOutra = outros
    .map((x, i) => ({ x, i }))
    .sort((a, b) => a.x.nome.localeCompare(b.x.nome, 'pt-BR'))
    .map(({ x, i }) => `<li><button class="arv ${externo === x ? 'sel' : ''}" data-a="times-externo" data-id="${i}">${escudo(x)}${esc(x.nome)}</button></li>`)
    .join('');
  // seleção por país e campeonato: Brasil (Série A e B, com tudo) e as ligas estrangeiras cadastradas (elencos para consulta)
  const paisSel = app.times.pais ?? 'Brasil';
  const paisMundo = PAISES_MUNDO.find((p) => p.nome === paisSel);
  // jogo com o mundo inteiro: os clubes estrangeiros são de verdade (mesma tela dos brasileiros); senão, só consulta da planilha
  const mundoReal = Boolean(e.mundo && paisSel !== 'Brasil' && paisMundo);
  const ehMundo = paisSel !== 'Brasil' && Boolean(paisMundo) && !e.mundo && !e.ligaMundo;
  const ligasDoPais: { id: string; nome: string }[] = (ehMundo || mundoReal) && paisMundo ? paisMundo.ligas : [{ id: 'br-a', nome: 'Brasileirão Série A' }, { id: 'br-b', nome: 'Brasileirão Série B' }];
  const ligaPadrao = ehMundo || mundoReal ? (ligasDoPais[0] as { id: string }).id : divisaoDoHumano(e) === 2 ? 'br-b' : 'br-a';
  const ligaSel = ligasDoPais.some((l) => l.id === app.times.liga) ? (app.times.liga as string) : ligaPadrao;
  const opcoesPais = ['Brasil', ...PAISES_MUNDO.map((p) => p.nome)].map((n) => `<option value="${esc(n)}" ${n === (ehMundo || mundoReal ? paisSel : 'Brasil') ? 'selected' : ''}>${esc(n)}</option>`).join('');
  const opcoesLiga = ligasDoPais.map((l) => `<option value="${l.id}" ${l.id === ligaSel ? 'selected' : ''}>${esc(l.nome)}</option>`).join('');
  const clubesMundo = ehMundo ? clubesDaLiga(ligaSel) : [];
  const mundoSel = clubesMundo.find((m) => m.nome === app.times.mundo) ?? null;
  const itensLiga = ehMundo
    ? clubesMundo.map((m, i) => `<li><button class="arv ${mundoSel === m ? 'sel' : ''}" data-a="times-mundo" data-id="${i}">${escudoMundo(m.nome)}${esc(m.nome)}</button></li>`).join('')
    : mundoReal
      ? e.clubes.filter((x) => x.liga === ligaSel).sort(porNome).map(itemClube).join('')
      : e.ligaMundo
        ? lista
        : e.acesso
      ? clubesDaDivisao(e, ligaSel === 'br-b' ? 2 : 1).sort(porNome).map(itemClube).join('')
      : (ligaSel === 'br-b' ? 2 : 1) === divisaoDoHumano(e)
        ? lista
        : listaOutra;
  const tituloLiga = ehMundo || mundoReal || e.ligaMundo ? '' : logoCampeonato(ligaSel === 'br-b' ? 'serie-b' : 'liga', 18);
  const listaLiga = `<div class="pn-tit"><span>${tituloLiga}${esc(ligasDoPais.find((l) => l.id === ligaSel)?.nome ?? '')}</span></div>
    ${e.ligaMundo ? '' : `<div class="combos"><select data-ch="times-pais" aria-label="País">${opcoesPais}</select><select data-ch="times-liga" aria-label="Campeonato">${opcoesLiga}</select></div>`}
    <ul class="arvore">${itensLiga}</ul>`;
  const mi = (v: number): string => (v > 0 ? dinheiroCurto(v * 1_000_000) : '—');
  const painelMundo = mundoSel
    ? `<div class="times-cab">${escudoMundo(mundoSel.nome, true)}<div><b>${esc(mundoSel.nome)}</b><br><span class="cinza">${esc(ligasDoPais.find((l) => l.id === ligaSel)?.nome ?? '')} · ${esc(paisSel)}</span><br>${mundoSel.forca ? `Força do time: <b>${mundoSel.forca}</b> · ` : ''}${mundoSel.elenco.length} jogadores<br><span class="cinza">Clube de outra liga: para contratar, use a Procura.</span></div></div>
      <div class="rolavel resultados alta"><table class="tab-dlg"><thead><tr><th>P</th><th class="esq">Nome</th><th>Idade</th><th>Força</th><th>Valor</th></tr></thead><tbody>${mundoSel.elenco
        .map((j) => `<tr><td title="${esc(j[1])}">${esc(j[1].split(/[ -]/).map((s) => s[0]).join('').slice(0, 3).toUpperCase())}</td><td class="esq">${esc(j[0])}</td><td class="${classeIdade(j[2])}">${j[2] > 0 ? j[2] : '—'}</td><td>${forcaDoJogador(j) ?? '—'}</td><td>${mi(j[3])}</td></tr>`)
        .join('')}</tbody></table></div>`
    : '<p class="cinza" style="padding:12px">Escolha um clube da lista para ver o elenco.</p>';  const total = c.elenco.reduce((s, j) => s + j.valor, 0);
  const selJ = c.elenco.find((j) => j.id === app.times.jogadorId) ?? null;
  const linhas = elencoOrdenado(c)
    .map(
      (j) => `<tr class="lin${selJ && j.id === selJ.id ? ' sel' : ''}" data-a="times-jog" data-id="${j.id}" tabindex="0"><td title="${NOME_FUNCAO[funcaoDe(j)]}">${funcaoDe(j)}</td><td class="esq">${esc(j.nome)}${estrelasHtml(j)}</td><td>${j.lado}</td><td>${j.overall}</td>
        <td>${dinheiroCurto(j.salario)}</td><td>${dinheiroCurto(j.valor)}</td><td>${textoCaracteristicas(j)}</td><td>${j.gols}</td><td class="${classeIdade(j.idade)}">${j.idade}</td></tr>`,
    )
    .join('');
  const info = selJ
    ? `<span class="foto-jog">${rosto(selJ.nome, selJ.posicao, c.sigla)}</span><p><b>Função:</b> ${NOME_FUNCAO[funcaoDe(selJ)]}</p><p><b>Força:</b> ${selJ.overall} &nbsp; <b>Idade:</b> ${selJ.idade}</p><p><b>Jogos:</b> ${selJ.jogos} &nbsp; <b>Gols:</b> ${selJ.gols}</p>
       <p><b>Passe:</b> ${dinheiroExtenso(selJ.valor)}</p><p><b>Salário:</b> ${dinheiroCurto(selJ.salario)}</p><p><b>Contrato até:</b> ${textoContrato(e, selJ)}</p>
       <p><b>${selJ.caracteristicas.map((i) => CARACTERISTICAS_NOME[i]).join('/')}</b></p>${blocoHabilidades(selJ)}`
    : '<p class="cinza">Selecione um jogador.</p>';
  const h = humano();
  const acoes =
    selJ && !externo && c.id !== e.humanoId
      ? (() => {
          const pedido = precoPedido(selJ, c);
          const dado = `data-id="${selJ.id}" data-club="${c.id}"`;
          const cheio = h.elenco.length >= ELENCO_MAX;
          return `<button class="btn" data-a="oferta" ${dado} ${cheio ? 'disabled' : ''}>Fazer oferta</button>
            <button class="btn principal" data-a="comprar" ${dado} ${h.caixa < pedido || cheio || (app.online && c.humano) ? 'disabled' : ''} ${app.online && c.humano ? 'title="Jogador de outro técnico: faça uma oferta"' : ''}>Comprar (${dinheiroCurto(pedido)})</button>`;
        })()
      : '';
  return dialogo(
    'Times',
    `<div class="dlg-corpo times">
      <div class="times-esq">${listaLiga}
        <div class="info-jog"><div class="pn-tit"><span>${selJ ? esc(selJ.nome) + ' - ' + selJ.posicao : 'Jogador'}</span></div><div class="pn-corpo">${info}</div></div></div>
      <div class="times-dir">${ehMundo ? painelMundo : `<div class="times-cab">${escudo(c, true)}<div><b>${esc(c.nome)}</b><br><span class="cinza">${esc(e.tecnico && c.id === e.humanoId ? e.tecnico : (c.tecnico ?? 'Técnico'))} · reputação ${c.reputacao}</span><br>Valor do elenco: ${dinheiroCurto(total)}${c.elenco.some((j) => j.dadosEstimados === 'elenco gerado') ? '<br><span class="cinza">Elenco gerado: este clube ainda não tem os jogadores reais cadastrados.</span>' : ''}</div>
        <div class="conf-mini">${barraMini('Diretoria', c.confiancaDiretoria)}${barraMini('Torcida', c.confiancaTorcida)}</div></div>
        <div class="rolavel resultados alta"><table class="tab-dlg"><thead><tr><th>P</th><th class="esq">Nome</th><th>L</th><th>F</th><th>Salário</th><th>Valor</th><th>Car.</th><th>G</th><th>Idade</th></tr></thead><tbody>${linhas}</tbody></table></div>`}</div>
    </div>
    <div class="dlg-botoes"><span class="rotulo-sel">${icone('estadio', 16)} ${dinheiroExtenso(h.caixa)}</span>${acoes}<button class="btn" data-a="fechar">Fechar</button></div>`,
    'grande',
  );
}

function barraMini(rotulo: string, pct: number): string {
  return `<div class="mini"><span>${rotulo}</span><div class="conf-barra pequena"><i style="width:${pct}%"></i><b>${pct}%</b></div></div>`;
}

export function dlgNegociacao(): string {
  const e = jogoAtual();
  const n = app.negociacao;
  if (!n) return '';
  const dono = e.clubes.find((c) => c.elenco.some((j) => j.id === n.jogadorId));
  const j = dono?.elenco.find((x) => x.id === n.jogadorId);
  if (!dono || !j) return '';
  const pedido = precoPedido(j, dono);
  let resposta = '';
  const r = n.resposta;
  if (r?.tipo === 'recusada') resposta = `<div class="aviso-bf">Recusada: ${esc(r.motivo)}.</div>`;
  if (r?.tipo === 'contraproposta') {
    resposta = `<div class="aviso-bf">${esc(dono.nome)} só fecha por ${dinheiroExtenso(r.valor)}.
      <button class="btn principal" data-a="aceitar-contra" data-valor="${r.valor}">Aceitar ${dinheiroCurto(r.valor)}</button></div>`;
  }
  return dialogo(
    'Fazer oferta',
    `<div class="dlg-tit amarelo">Fazer oferta por ${esc(j.nome)}</div>
    <div class="dlg-corpo"><p>${esc(dono.nome)} · ${NOME_FUNCAO[funcaoDe(j)]} ·${j.idade} anos · força <b>${j.overall}</b> · passe ${dinheiroExtenso(j.valor)}</p>
    <p>Pedido do clube: <b>${dinheiroExtenso(pedido)}</b> · seu caixa: ${dinheiroExtenso(humano().caixa)}</p>
    <div class="leiloar-linha"><span class="leiloar-rot">Sua oferta</span>${campoDinheiro('oferta', n.oferta, {
      min: 0,
      ref: pedido,
      rotulo: 'Sua oferta em reais',
      botoes: [{ rotulo: 'Valor pedido', delta: 'ref' }, { rotulo: '−500 mil', delta: -500_000 }, { rotulo: '−100 mil', delta: -100_000 }, { rotulo: '+100 mil', delta: 100_000 }, { rotulo: '+500 mil', delta: 500_000 }],
    })}</div>${resposta}</div>
    <div class="dlg-botoes"><button class="btn principal" data-a="proposta">Enviar proposta</button><button class="btn" data-a="fechar-neg">Cancelar</button></div>`,
    'medio',
    'fechar-neg',
  );
}

export function dlgOfertas(): string {
  const e = jogoAtual();
  const o = app.ofertasVenda;
  if (!o) return '';
  const j = humano().elenco.find((x) => x.id === o.jogadorId);
  if (!j) return '';
  const itens = o.ofertas
    .map((of) => {
      const c = clubePorId(e, of.clubeId);
      return `<tr><td class="esq">${escudo(c)}${esc(c.nome)}</td><td>${dinheiroExtenso(of.valor)}</td><td><button class="btn principal" data-a="vender-p" data-id="${j.id}" data-comp="${c.id}" data-valor="${of.valor}">Vender</button></td></tr>`;
    })
    .join('');
  return dialogo(
    o.soLeilao ? 'Leiloar jogador' : 'Vender jogador',
    `<div class="dlg-tit amarelo">${o.soLeilao ? 'Leiloar' : 'Ofertas por'} ${esc(j.nome)} (passe ${dinheiroExtenso(j.valor)})</div>
    <div class="dlg-corpo">${o.soLeilao ? '' : itens ? `<table class="tab-dlg"><tbody>${itens}</tbody></table>` : '<p>Nenhuma oferta disponível para esse jogador.</p>'}
    <p class="cinza peq">Você precisa ficar com ao menos 18 jogadores e 2 goleiros.</p>${app.online ? secaoLeiloar(j.id, j.valor) : ''}</div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'medio',
  );
}

// ---- Agenda, História e Opções -----------------------------------------------------------------

export function dlgAgenda(): string {
  const e = jogoAtual();
  const linhas = e.calendario
    .map((rodada, i) => {
      const conf = rodada.find((c) => c.mandante === e.humanoId || c.visitante === e.humanoId);
      if (!conf) return '';
      const casa = conf.mandante === e.humanoId;
      const adv = clubePorId(e, casa ? conf.visitante : conf.mandante);
      const r = e.resultados.find((x) => x.rodada === i && x.mandante === conf.mandante);
      let res = '–';
      let classe = '';
      if (r) {
        const pro = casa ? r.gols[0] : r.gols[1];
        const contra = casa ? r.gols[1] : r.gols[0];
        res = `${r.gols[0]} x ${r.gols[1]}`;
        classe = pro > contra ? 'vit' : pro < contra ? 'der' : 'emp';
      }
      const proxima = !r && i === e.rodada ? ' proxima' : '';
      return `<tr class="${classe}${proxima}"><td>${ehRodadaDeLibertadores(e, i) ? (e.sulamericana?.slots.includes(i) ? 'Sul' : 'Lib') : ehRodadaDeCopa(e, i) ? 'Copa' : numeroRodadaLiga(e, i)}</td><td>${dataBR(dataDaRodada(e.temporada, i))}</td><td>${casa ? 'Casa' : 'Fora'}</td><td class="esq">${escudo(adv)}${esc(adv.nome)}</td><td>${res}</td></tr>`;
    })
    .join('');
  return dialogo(
    'Agenda',
    `<div class="dlg-tit amarelo">Jogos do seu time - temporada ${e.temporada}</div>
    <div class="dlg-corpo rolavel alta"><table class="tab-dlg"><thead><tr><th>Rod.</th><th>Data</th><th>Local</th><th class="esq">Adversário</th><th>Placar</th></tr></thead><tbody>${linhas}</tbody></table></div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'medio',
  );
}

export function dlgHistoria(): string {
  const e = jogoAtual();
  const linhas = [...e.historico]
    .reverse()
    .map((h) => `<tr><td>${dataDaRodada(h.temporada, 0).getUTCFullYear()}</td><td class="esq">${escudo(clubePorId(e, h.campeaoId))}${esc(clubePorId(e, h.campeaoId).nome)}</td><td>${h.fase ? esc(h.fase) : ordinal(h.posicaoHumano)}</td></tr>`)
    .join('');
  const aba = app.historia.aba;
  const abas = `<div class="abas" role="tablist"><button class="aba ${aba === 'campeoes' ? 'ativa' : ''}" data-a="hist-aba" data-p="campeoes" role="tab">Campeões</button>
    <button class="aba ${aba === 'trofeus' ? 'ativa' : ''}" data-a="hist-aba" data-p="trofeus" role="tab">Galeria de Troféus</button></div>`;
  const corpo =
    aba === 'campeoes'
      ? `<div class="dlg-tit amarelo">${logoCampeonato(e.formato === 'copa' ? 'copa' : divisaoDoHumano(e) === 2 ? 'serie-b' : 'liga', 24)}Campeões - ${esc(nomeCompeticao(e))}</div>
        <div class="dlg-corpo rolavel alta">${linhas ? `<table class="tab-dlg"><thead><tr><th>Ano</th><th class="esq">Campeão</th><th>Seu time</th></tr></thead><tbody>${linhas}</tbody></table>` : '<p class="cinza">Nenhuma temporada concluída ainda.</p>'}${(() => {
          // acesso e rebaixamento: o que aconteceu em cada temporada (só nos jogos com as duas divisões)
          const nome = (id: number): string => esc(clubePorId(e, id).nome);
          const itens = [...e.historico]
            .reverse()
            .filter((h) => h.rebaixados && h.promovidos)
            .map(
              (h) =>
                `<li><b>${dataDaRodada(h.temporada, 0).getUTCFullYear()}</b> · caíram: ${(h.rebaixados as number[]).map(nome).join(', ')} · subiram: ${(h.promovidos as number[]).map(nome).join(', ')}</li>`,
            )
            .join('');
          return itens ? `<h3 class="fase-tit">Acesso e rebaixamento</h3><ul class="pn-lista">${itens}</ul>` : '';
        })()}</div>`
      : `<div class="dlg-tit amarelo">Galeria de Troféus</div><div class="dlg-corpo rolavel alta">${abaTrofeusClube(e)}</div>`;
  return dialogo('História', `${abas}${corpo}<div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`, 'medio');
}

/** Registro do que a sala online fez (rodadas, prazos, encerramentos): ajuda a entender por que o jogo andou. */
function registroSala(): string {
  const v = app.online?.visao;
  if (!v || v.sala.registro.length === 0) return '';
  const linhas = [...v.sala.registro]
    .reverse()
    .map((r) => `<li><span class="cinza">${new Date(r.t).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}</span> ${esc(r.texto)}</li>`)
    .join('');
  return `<div class="registro-sala"><h3 class="fase-tit">Registro da sala</h3><ul>${linhas}</ul></div>`;
}

export function dlgOpcoes(): string {
  const e = jogoAtual();
  const fim = temporadaAcabou(e);
  const vel = (v: number, nome: string): string => `<option value="${v}" ${app.velocidade === v ? 'selected' : ''}>${nome}</option>`;
  return dialogo(
    'Opções',
    `<div class="dlg-tit amarelo">Opções</div>
    <div class="dlg-corpo opcoes">
      <label class="campo-linha">Velocidade das partidas <select data-ch="velocidade">${vel(1, 'Normal')}${vel(3, 'Rápida')}${vel(0, 'Só o resultado')}</select></label>
      <label class="campo-linha">Fechar a janela ao clicar fora dela <select data-ch="fechar-fora"><option value="sim" ${app.fecharAoClicarFora ? 'selected' : ''}>Ligado</option><option value="nao" ${app.fecharAoClicarFora ? '' : 'selected'}>Desligado</option></select></label>
      ${app.online ? '' : `<label class="campo-linha" title="No fim da temporada, com o caixa em ${dinheiroExtenso(SALDO_DEMISSAO)} ou pior, o técnico é demitido e escolhe uma proposta de outro clube">Demissão por caixa negativo (${dinheiroExtenso(SALDO_DEMISSAO)} ou pior) <select data-ch="demissao-caixa"><option value="sim" ${e.semDemissaoPorCaixa ? '' : 'selected'}>Ligada</option><option value="nao" ${e.semDemissaoPorCaixa ? 'selected' : ''}>Desligada</option></select></label>`}
      <label class="campo-linha">Mini-game ao sofrer pênalti (teste) <select data-ch="minigame"><option value="sim" ${app.minigame ? 'selected' : ''}>Ligado</option><option value="nao" ${app.minigame ? '' : 'selected'}>Desligado</option></select></label>
      <label class="campo-linha">Som da partida (gols e pênaltis) <select data-ch="som"><option value="sim" ${somLigado() ? 'selected' : ''}>Ligado</option><option value="nao" ${somLigado() ? '' : 'selected'}>Desligado</option></select></label>
      <div class="grade-btn">
        <button class="btn" data-a="salvar">${icone('salvar', 16)} Salvar agora</button>
        <button class="btn" data-a="exportar">Exportar save</button>
        <button class="btn" data-a="importar">Importar save</button>
        <button class="btn" data-a="ate-fim" ${fim ? 'disabled' : ''}>Simular até o fim da temporada</button>
        <button class="btn principal" data-a="encerrar" ${fim ? '' : 'disabled'}>Encerrar temporada</button>
        <button class="btn" data-a="novo-jogo">Novo jogo</button>
        <button class="btn" data-a="menu-inicial">${icone('casa', 16)} Menu inicial</button>
      </div>
      ${(() => {
        // conquistas e XP do jogo solo: só com conta logada; o servidor confere cada rodada e assina o save exportado
        if (app.online) return '';
        const c = usuarioDaConta();
        if (!c) return '<p class="cinza peq">Conquistas e XP do jogo solo: entre numa conta (botão de conta, no topo) para ativá-los. Com a conta, o save exportado também vai assinado.</p>';
        return `<p class="cinza peq">Conquistas e XP do jogo solo: <b>${estadoSelo.ok ? 'ativos' : 'desativados neste jogo'}</b>${estadoSelo.ultimaRodada ? ` · último selo: ${esc(estadoSelo.ultimaRodada)}` : ''}${estadoSelo.texto ? ` · ${esc(estadoSelo.texto)}` : ''}</p>`;
      })()}
      ${secaoAparencia()}
      ${(() => {
        const c = usuarioDaConta();
        if (app.online) return '';
        return c
          ? `<div class="grade-btn"><button class="btn" data-a="online-conta-salvar">☁ Salvar jogo na conta (${esc(c.usuario)})</button><button class="btn" data-a="online-conta-carregar" ${c.temSave ? '' : 'disabled'}>☁ Carregar jogo da conta</button></div>`
          : '<p class="cinza peq">Entre numa conta (menu ONLINE) para guardar o seu jogo solo na nuvem.</p>';
      })()}
      ${registroSala()}
      <input type="file" id="arquivo" accept="application/json,.json" hidden />
      <p class="cinza peq">O jogo salva sozinho no navegador a cada rodada. Clubes e jogadores reais da Série A 2026 (força estimada).</p>
    </div>
    <div class="dlg-botoes"><button class="btn" data-a="fechar">Fechar</button></div>`,
    'medio',
  );
}
